<template>
  <div class="wrap">
    <Swiper class="swiper_c" />
    <Content></Content>
  </div>
</template>

<script>
import Content from "./componenets/content.vue";
import Swiper from "./componenets/swiper.vue";
export default {
  components: {
    Content,
    Swiper,
  },
  data() {
    return {
    };
  },
  created() {},
  methods: {},
};
</script>

<style  lang='scss' scoped>
.wrap {
  background-color: #f7f7f7;
}

.swiper_c {
  width: 100%;
  height: 500px;
}
// .home_solve {
//   padding-top: 0rem;
// }

// @media screen and (min-width: 768px) and (max-width: 1920px) {
//   .wrap {
//     overflow: hidden;
//   }

//   .banner_wrap {
//     position: relative;
//     width: 100%;
//     height: calc(100vh - 0.8rem);
//     background-color: rgba(0, 0, 0, 0.35);
//     ;
//   }

//   .loading {
//     position: absolute;
//     width: 100%;
//     height: calc(100vh - 0.8rem);
//     background-color: rgba(0, 0, 0, 0.35);
//     z-index: 1;
//   }

//   .banner {
//     background-size: cover;
//     height: 100%;
//     width: calc(100% + 100px);
//     left: -50px;

//     &:before {
//       width: 100%;
//       height: 100%;
//       content: '';
//       background: fade(#000, 35);
//       display: block;
//     }
//   }

//   .banner_span_wrap {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     position: absolute;
//     top: 0;
//     bottom: 0;
//     right: 0;
//     left: 0;
//     margin: 0 auto;
//     z-index: 2;
//     background-image: '@/assets/images/banner/resolvePlan.png';
//   }

//   .banner_span1,
//   .banner_span2 {
//     color: #fff;
//   }

//   .banner_span1 {
//     font-size: 0.56rem;
//     line-height: 0.70rem;
//   }

//   .banner_span2 {
//     font-size: 0.16rem;
//     line-height: 0.40rem;
//   }

//   .content {
//     padding: 0.7rem 0;
//   }
// }

// @media screen and (max-width: 768px) {
//   .wrap {
//     overflow: hidden;
//   }

//   .banner_wrap {
//     position: relative;
//     width: 100%;
//     height: 7rem;
//     background-color: rgba(0, 0, 0, 0.35);
//     ;
//   }

//   .loading {
//     position: absolute;
//     width: 100%;
//     height: 7rem;
//     background-color: rgba(0, 0, 0, 0.35);
//     z-index: 1;
//   }

//   .banner {
//     background: url("https://zos.alipayobjects.com/rmsportal/bXNBIyzSLHaycUGDzwLG.jpg") center;
//     background-size: cover;
//     height: 100%;
//     width: calc(100% + 0.5rem);
//     left: -0.25rem;

//     &:before {
//       width: 100%;
//       height: 100%;
//       content: '';
//       background: fade(#000, 35);
//       display: block;
//     }
//   }

//   .banner_span_wrap {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     position: absolute;
//     top: 0;
//     bottom: 0;
//     right: 0;
//     left: 0;
//     margin: 0 auto;
//     z-index: 2;
//   }

//   .banner_span1,
//   .banner_span2 {
//     color: #fff;
//   }

//   .banner_span1 {
//     font-size: 0.76rem;
//     line-height: 0.9rem;
//   }

//   .banner_span2 {
//     font-size: 0.36rem;
//     line-height: 0.6rem;
//   }

//   .content {
//     padding: 0.7rem 0;
//   }

// }
</style>